import React, { FC } from 'react';
import useLocales from 'hooks/useLocales';
import { termsConditions } from 'constants/constants';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer/Index';
import PrivacyPolicyTermsCard from 'components/PrivacyPolicyCard';
import { IPrivacyPolicyTerms } from 'hooks/type';

import './index.scss';
import { useSelector } from 'react-redux';
import { IMe } from 'core/interface/me';

const TermsConditions: FC = (): JSX.Element => {
  const { t } = useLocales();
  const me = useSelector((state: IMe) => state.user).user;

  const isAuthenticated = me !== null;

  return (
    <div
      className="privacyPolicy"
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    >
      {isAuthenticated && <Navbar />}
      <div className="privacyPolicy_content" style={{ flex: 1 }}>
        <h1 className="privacyPolicy_title">{t('General Terms')}</h1>
        <div className="privacyPolicy_texts">
          {termsConditions.map((e: IPrivacyPolicyTerms, i: number) => (
            <PrivacyPolicyTermsCard
              title={t(e.title)}
              key={i}
              content={t(e.content)}
              className="terms_context_terms"
            />
          ))}
          <div className="privacyPolicy_content_privacybeleid">
            {t('Skillio Privacybeleid, © 2025 Skillio.com. All rights reserved.')}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;
